import { ServiceFamiliesResponseDTO } from "../../../../../requests-module"


import axios, { AxiosResponse } from "axios"

import APIService from '../APIService/APIServiceImpl'
import OptionFamiliesService from './OptionFamiliesServiceV1'
import { defaultServiceFamilies } from "../../../config/defaultServiceFamilies"

export default class OptionFamiliesServiceImpl
    extends APIService
    implements OptionFamiliesService {
    constructor() {
        // const serviceUrl = `https://qd4dm2zh45.execute-api.eu-west-3.amazonaws.com/dev/service_families`
        // const serviceUrl = `https://d3d2w37bp6469.cloudfront.net/cms/service-families`
        const serviceUrl = window.env.VUE_APP_FAMILIES_SERVICE_URL || 'https://d3d2w37bp6469.cloudfront.net/cms/service-families'
        super(serviceUrl)
    }

    async getOptionFamilies(): Promise<ServiceFamiliesResponseDTO> {
        try {
            const headers = {
                ...this.getDefaultHeaders(),
            }
            const url = `${this.getServiceUrl()}/all`
            const response: AxiosResponse<ServiceFamiliesResponseDTO> = await axios.get(url, {
                headers,
            })
            return response.data;
        } catch (error) {
            // Endpoint fails
            return defaultServiceFamilies;
        }
    }

}
